import { TAG } from '../../tag/TAG';
import { CreateLensRequest } from '../types/CreateLensRequest';
import { LensPatchMessage } from '../types/PatchRequest';
import { UserEditCapability, UserPermissionsMetadataForLensMetadataResponse } from '../types/UserPermission';
import { LensCreationResponse } from '../types/CreateLensResponse';

export class LensesTAG {
  public canEditLens = async (lensId: string): Promise<boolean> => {
    const result  = await TAG.Get<UserPermissionsMetadataForLensMetadataResponse>(`monolith-lens/lenses/permissions?lensId=${lensId}`);
    return result.user_lens_capabilities.some((cap) => {
      return cap.capability === UserEditCapability.WRITE && cap.is_allowed;
    });
  };

  public editDescription = async (lensId: string, description: string): Promise<LensPatchMessage> => {
    const message: LensPatchMessage = {lens :{description}};
    return TAG.Patch(`monolith-lens/lenses/${lensId}`, message);
  };

  public editName = async (lensId: string, name: string): Promise<LensPatchMessage> => {
    const message: LensPatchMessage = {lens :{name}};
    return TAG.Patch(`monolith-lens/lenses/${lensId}`, message);
  };

  public createLens = async (lens: CreateLensRequest): Promise<LensCreationResponse> => {
    return TAG.Post('monolith-lens/lenses', {lens});
  };
}

export const LensesTAGHandler = new LensesTAG();
